// @ts-nocheck
import $ from "jquery";
import { createI18n } from "vue-i18n";
import { createApp, h, Transition, TransitionGroup } from "vue";
import { createHead } from "@unhead/vue";
import VueProgressBar from "@aacassandra/vue3-progressbar";
import VueCookies from "vue3-cookies";
import VueClickAway from "vue3-click-away";
import { plugin as FormKitPlugin, defaultConfig } from "@formkit/vue";
import "@formkit/themes/genesis";
import config from "../formkit.config.ts";
import { Skeletor } from "vue-skeletor";
import "vue-skeletor/dist/vue-skeletor.css";
import 'htmx.org';

import './utils/htmx.js';
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Meta from 'vue-meta';
import deuFooterHeader, { Header, Footer } from "@deu/deu-header-footer";
import UniversalPiwik from "./plugins/piveau-universal-piwik";

// Import Font Awesome Icons Library for vue
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faGoogle,
  faGooglePlus,
  faGooglePlusG,
  faFacebook,
  faFacebookF,
  faInstagram,
  faTwitter,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import {
  faComment,
  faExternalLinkAlt,
  faPlus,
  faMinus,
  faArrowDown,
  faArrowUp,
  faInfoCircle,
  faExclamationTriangle,
  faThumbsUp as fasThummbsUp,
  faThumbsDown as fasThumbsDown,
} from '@fortawesome/free-solid-svg-icons';
import {
  faThumbsUp as farThumbsUp,
  faThumbsDown as farThumbsDown,
} from '@fortawesome/free-regular-svg-icons';
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { glueConfig as GLUE_CONFIG, i18n as I18N_CONFIG } from '../config/user-config.js';
import runtimeConfig from '../config/runtime-config.js';
import router from './router.js';

import App from "./App";
import {
  dateFilters,
  AppSnackbar,
  AppConfirmationDialog,
  bulkDownloadCorsProxyService,
  corsProxyService,
  runtimeConfigurationService,
  store,
  configureModules,
  InfoSlot,
  ConditionalInput,
  AutocompleteInput,
  UniqueIdentifierInput,
  FileUpload,
} from '@piveau/piveau-hub-ui-modules';

import searchStore from './store/search';
store.registerModule('search', searchStore);

import '@piveau/piveau-hub-ui-modules/styles';

import { init } from "@deu/piveau-hub-ui-plugin-auth";

import ECSelectFacet from "@/components/ECSelectFacet";
import ECRadioFacet from "@/components/ECRadioFacet";
import ECMore from "@/components/ECMore";
import ECButton from "@/components/ECButton";
import ECInfo from "./components/ECInfo.vue";
import ECLinkButton from "./components/ECLinkButton.vue";
import ECDataInfoBox from "./components/ECDataInfoBox.vue";
import ECDistributionDetails from "@/components/datasetDetails/ECDistributionDetails";
import ECDistributionsHeader from "@/components/datasetDetails/ECDistributionsHeader";
import ECSubNavigation from "@/components/ECSubNavigation.vue";
import ECDistributionVisualisation from "@/components/distribtutionVisualisation/DistributionVisualisation.vue";
import ECDatasetDetailsDataset from "@/components/datasetDetails/ECDatasetDetailsDataset.vue";
import ECDatasetDetailsSmiliarDatasets from "./components/datasetDetails/ECDatasetDetailsSmiliarDatasets.vue";
import ECDatasetDetailsFeatureHeader from "./components/datasetDetails/ECDatasetDetailsFeatureHeader.vue";
import ECDistributions from "./components/datasetDetails/ECDistributions.vue";
import DownloadAllDistributions from "@/components/DownloadAllDistributions.vue";

const NOTIFICATIONS_CACHE_TTL_MS = 30000;

const installDashboardNotificationsFetchCache = () => {
  if (typeof window === "undefined") return;

  const globalAny = globalThis;
  if (globalAny.__DEU_NOTIFICATIONS_FETCH_CACHE_INSTALLED__) return;

  const originalFetch = globalThis.fetch?.bind(globalThis);
  if (!originalFetch) return;

  const responseCache = new Map();

  const isNotificationsGetRequest = (url, method) =>
    method === "GET" && url.includes("/editorial/jsonapi/message/notification");

  const isMarkAllReadRequest = (url, method) =>
    method === "POST" && url.includes("/api/v1/notifications/read-all");

  const getMethod = (input, init = {}) => {
    const initMethod = (init.method || "").toString().toUpperCase();
    if (initMethod) return initMethod;
    if (input instanceof Request) {
      return (input.method || "GET").toUpperCase();
    }
    return "GET";
  };

  const getUrl = (input) => {
    if (typeof input === "string") return input;
    if (input instanceof URL) return input.toString();
    if (input instanceof Request) return input.url;
    return "";
  };

  const getAuthHeader = (input, init = {}) => {
    const resolveHeaderValue = (headers, name) => {
      if (!headers) return "";
      if (headers instanceof Headers) return headers.get(name) || "";
      if (Array.isArray(headers)) {
        const pair = headers.find(([key]) => key.toLowerCase() === name.toLowerCase());
        return pair?.[1] || "";
      }
      const key = Object.keys(headers).find((h) => h.toLowerCase() === name.toLowerCase());
      return key ? headers[key] || "" : "";
    };

    const fromInit = resolveHeaderValue(init.headers, "authorization");
    if (fromInit) return fromInit;

    if (input instanceof Request) {
      return input.headers.get("authorization") || "";
    }

    return "";
  };

  globalThis.fetch = async (input, init = {}) => {
    const method = getMethod(input, init);
    const url = getUrl(input);

    if (isMarkAllReadRequest(url, method)) {
      responseCache.clear();
      return originalFetch(input, init);
    }

    if (!isNotificationsGetRequest(url, method)) {
      return originalFetch(input, init);
    }

    const authHeader = getAuthHeader(input, init);
    const cacheKey = `${url}::${authHeader}`;
    const now = Date.now();
    const cached = responseCache.get(cacheKey);

    if (cached && now - cached.createdAt < NOTIFICATIONS_CACHE_TTL_MS) {
      return cached.response.clone();
    }

    const response = await originalFetch(input, init);
    if (response.ok) {
      responseCache.set(cacheKey, {
        createdAt: now,
        response: response.clone(),
      });
    }

    return response;
  };

  globalAny.__DEU_NOTIFICATIONS_FETCH_CACHE_INSTALLED__ = true;
};

installDashboardNotificationsFetchCache();

const app = createApp(App);

// Compatibility alias for dependencies that still access Vue 2's this.$createElement.
app.config.globalProperties.$createElement = h;
// Compatibility aliases for libs resolving transition components by string name.
app.component("transition", Transition);
app.component("transition-group", TransitionGroup);
app.component("Transition", Transition);
app.component("TransitionGroup", TransitionGroup);

app.use(runtimeConfigurationService, runtimeConfig, {
  baseConfig: GLUE_CONFIG,
  debug: false,
});

const env = app.config.globalProperties.$env;

const isEmbedRoute = () => {
  if (typeof window === "undefined") return false;

  const pathname = (window.location.pathname || "").toLowerCase();
  const searchParams = new URLSearchParams(window.location.search || "");
  const embedParam = searchParams.get("embed");
  const isEmbedPath = pathname.endsWith("/embed") || pathname.endsWith("/embed-snippet");
  const isEmbedQuery = ["1", "true", "yes", "on"].includes((embedParam || "").toLowerCase());

  return isEmbedPath || isEmbedQuery;
};

const resolveAuthMiddlewareBaseUrl = () => {
  const configuredBaseUrl =
    env?.authentication?.authMiddleware?.baseUrl || "/auth/middleware";

  if (typeof window === "undefined") return configuredBaseUrl;

  try {
    const resolvedUrl = new URL(configuredBaseUrl, window.location.origin);

    // Prefer same-origin middleware path to keep browser session handling stable.
    if (resolvedUrl.origin === window.location.origin) {
      return resolvedUrl.pathname.replace(/\/+$/, "");
    }

    return resolvedUrl.toString().replace(/\/+$/, "");
  } catch {
    return configuredBaseUrl;
  }
};

const authMiddlewareBaseUrl = resolveAuthMiddlewareBaseUrl();

app.config.globalProperties.devtools = true;

const { plugin: pvAuthPlugin, navigationGuardFn } = init({
  baseUrl: authMiddlewareBaseUrl,
  enabled:
    env?.authentication?.authMiddleware?.enable === "false"
      ? false
      : env?.authentication?.authMiddleware?.enable,
  seamlessLogin: isEmbedRoute()
    ? undefined
    : {
        cookieName: env.authentication.eulogin?.cookieName || 'eulogin_active_session',
        cookieHost: env.authentication.eulogin?.cookieHost || 'data.europa.eu',
      },

  refreshInterval: 120000,
  defaultLoginOptions: {
    redirect_url: `${window.location.origin}/data/login-redirect`,
    routerBase: '/data',
    requestParameters: {
      acr_values:
        env.authentication.authMiddleware?.acrValues ||
        "https://ecas.ec.europa.eu/loa/medium",
    },
  },
  defaultLogoutOptions: {
    post_logout_redirect_url: `${window.location.origin}/data/logout-redirect`,
    redirect_url: `${window.location.origin}/data/logout-redirect`,
  },
});

app.use(pvAuthPlugin);

app.use(VueClickAway);

app.use(FormKitPlugin, defaultConfig(config));

const head = createHead();
app.use(head);

configureModules(app, store, {
  components: {
    DownloadAllDistributions,
    SelectFacet: ECSelectFacet,
    RadioFacet: ECRadioFacet,
    PvShowMore: ECMore,
    PvButton: ECButton,
    PvBanner: ECInfo,
    PvDataInfoBox: ECDataInfoBox,
    DatasetDetailsNavigationPage: ECLinkButton,
    DistributionDetails: ECDistributionDetails,
    DistributionsHeader: ECDistributionsHeader,
    SubNavigation: ECSubNavigation,
    DistributionVisualisationSlot: ECDistributionVisualisation,
    DatasetDetailsDataset: ECDatasetDetailsDataset,
    DatasetDetailsSmiliarDatasets: ECDatasetDetailsSmiliarDatasets,
    DatasetDetailsFeatureHeader: ECDatasetDetailsFeatureHeader,
    Distributions: ECDistributions,
  },
  services: GLUE_CONFIG.services,
  serviceParams: {
    baseUrl: env.api.baseUrl,
    qualityBaseUrl: env.api.qualityBaseUrl,
    similarityBaseUrl: env.api.similarityBaseUrl,
    similarityServiceName: env.api.similarityServiceName,
    gazetteerBaseUrl: env.api.gazetteerBaseUrl,
    hubUrl: env.api.hubUrl,
    keycloak: env.authentication.keycloak,
    rtp: env.authentication.rtp,
    useAuthService: env.authentication.useService,
    authToken: env.authentication.authToken,
    defaultScoringFacets:
      env.content.datasets.facets.scoringFacets.defaultScoringFacets,
  },
});

app.component("InfoSlot", InfoSlot);
app.component("ConditionalInput", ConditionalInput);
app.component("AutocompleteInput", AutocompleteInput);
app.component("UniqueIdentifierInput", UniqueIdentifierInput);
app.component("FileUpload", FileUpload);

app.component("AppSnackbar", AppSnackbar);
app.component("AppConfirmationDialog", AppConfirmationDialog);

app.component(Skeletor.name, Skeletor);

app.use(VueCookies);

app.use(corsProxyService, env.api.corsproxyApiUrl);
app.use(bulkDownloadCorsProxyService, GLUE_CONFIG, env.api.corsproxyApiUrl);

const { isPiwikPro, siteId, trackerUrl } = env.tracker;
app.use(UniversalPiwik, {
  // disabled: typeof env.tracker.disabled === "boolean" && env.tracker.disabled,
  router,
  isPiwikPro,
  trackerUrl,
  siteId,
  debug: process.env.NODE_ENV === "development",
  useSuspendFeature: false,
  pageViewOptions: {
    // Set this to true as long as navigating to the /datasets/ route
    // adds a 'minScore' query to prevent duplicated tracking
    useDatasetsMinScoreFix: false,
    // Send empty dataset metadata for every page view
    // See https://gitlab.fokus.fraunhofer.de/piveau/organisation/piveau-scrum-board/-/issues/2098
    beforeTrackPageView: (to, from, tracker) => {
      if (to.name !== "DatasetDetailsDataset") {
        tracker.trackDatasetDetailsPageView(null, null, {
          dataset_AccessRights: "",
          dataset_AccrualPeriodicity: "",
          dataset_Catalog: "",
          dataset_ID: "",
          dataset_Publisher: "",
          dataset_Title: "",
        });
      }
    },
  },
});

// Vue i18n
const LOCALE = env.languages.locale;
const FALLBACKLOCALE = env.languages.fallbackLocale;

const i18n = createI18n({
  locale: LOCALE,
  fallbackLocale: FALLBACKLOCALE,
  messages: I18N_CONFIG,
  allowComposition: true,
  legacy: false,
  globalInjection: true,
  fallbackWarn: false,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  warnHtmlMessage: false,
});

app.config.globalProperties.i18n = i18n;
app.use(i18n);

// Set locale for dateFilters
dateFilters.setLocale(LOCALE);

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

// Bootstrap requirements to use js-features of bs-components
import "popper.js";

import "bootstrap";

import "./styles/styles.scss";
import "./styles/ec-style.scss";

$(() => {
  $('[data-toggle="popover"]').popover({ container: "body" });
  $('[data-toggle="tooltip"]').tooltip({ container: "body" });
});

import "@fortawesome/fontawesome-free/css/all.css";

import "@deu/deu-header-footer/dist/deu-header-footer.css";

// OpenStreetMaps popup styles
import "leaflet/dist/leaflet.css";

// Vue-progressbar setup
const progressBarOptions = {
  thickness: "5px",
  autoRevert: false,
  transition: {
    speed: "1.0s",
    opacity: "0.5s",
    termination: 1000,
  },
};
app.use(VueProgressBar, progressBarOptions);
import CodeDiff from "v-code-diff";

app.use(CodeDiff);
app.use(deuFooterHeader, { i18n });
app.component("deu-header", Header);
app.component("deu-footer", Footer);


// Add Font Awesome Icons
library.add(faGoogle, faGooglePlus, faGooglePlusG, faFacebook, faFacebookF, faInstagram, faTwitter, faLinkedinIn, faComment, faExternalLinkAlt, faPlus, faMinus, faArrowDown, faArrowUp, faInfoCircle, faExclamationTriangle, farThumbsUp, farThumbsDown, fasThummbsUp, fasThumbsDown);
app.component('font-awesome-icon', FontAwesomeIcon);

app.config.globalProperties.productionTip = false;

// Vue Router
app.use(router);
const SUPPORTED_LOCALES = Object.keys(I18N_CONFIG || {}).reduce(
  (acc, localeCode) => {
    acc[String(localeCode).toLowerCase()] = localeCode;
    return acc;
  },
  {}
);

const DEFAULT_LOCALE =
  SUPPORTED_LOCALES[String(LOCALE || FALLBACKLOCALE || "en").toLowerCase()] ||
  "en";

const INVALID_LOCALE_TOKENS = new Set(["", "undefined", "null", "nan"]);

const extractLocaleValue = (localeValue) =>
  Array.isArray(localeValue) ? localeValue[0] : localeValue;

const normalizeLocale = (localeValue, fallbackLocale = DEFAULT_LOCALE) => {
  const candidate = extractLocaleValue(localeValue);

  if (typeof candidate !== "string") {
    return fallbackLocale;
  }

  const normalizedCandidate = candidate.trim().toLowerCase();
  if (INVALID_LOCALE_TOKENS.has(normalizedCandidate)) {
    return fallbackLocale;
  }

  return SUPPORTED_LOCALES[normalizedCandidate] || fallbackLocale;
};

router.beforeEach((to, from, next) => {
  const fromLocale = normalizeLocale(from.query?.locale, DEFAULT_LOCALE);
  const normalizedToLocale = normalizeLocale(to.query?.locale, fromLocale);
  const currentToLocale = extractLocaleValue(to.query?.locale);

  if (currentToLocale !== normalizedToLocale) {
    next({
      ...to,
      query: {
        ...to.query,
        locale: normalizedToLocale,
      },
    });
    return;
  }

  next();
});
router.beforeEach(navigationGuardFn);
router.app = app;

// Vuex Store
app.use(store);

app.mount("#app");
